import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getReleases, getDSPServices, getSocialPlatforms, seedDefaults } from "@/lib/api";
import ReleaseCard from "@/components/ReleaseCard";
import { Skeleton } from "@/components/ui/skeleton";

export default function EmbedWidget() {
  const [releases, setReleases] = useState([]);
  const [dspServices, setDspServices] = useState([]);
  const [socialPlatforms, setSocialPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await seedDefaults();
        
        const [releasesRes, dspRes, socialRes] = await Promise.all([
          getReleases(),
          getDSPServices(),
          getSocialPlatforms(),
        ]);
        setReleases(releasesRes.data);
        setDspServices(dspRes.data);
        setSocialPlatforms(socialRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-background p-4" data-testid="embed-widget">
      {/* Compact Header */}
      <header className="mb-6">
        <a 
          href="https://underplay-preview-1.preview.emergentagent.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-3"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_music-connect-23/artifacts/mbsj96z9_UNDERPLAY%20MUSIC%20LOGO%20NEW%202025%20no%20border%20no%20TEXT.png" 
            alt="Underplay Recordings" 
            className="h-8 w-auto"
          />
          <span className="text-lg font-syne font-bold tracking-tight text-white">
            UNDERPLAY RECORDINGS
          </span>
        </a>
      </header>

      {/* Releases Grid */}
      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="rounded-xl overflow-hidden bg-background-surface">
              <Skeleton className="aspect-square w-full" />
              <div className="p-4 space-y-2">
                <Skeleton className="h-6 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      ) : releases.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-zinc-500">No releases yet</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {releases.map((release, index) => (
            <motion.div
              key={release.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <ReleaseCard
                release={release}
                dspServices={dspServices}
                socialPlatforms={socialPlatforms}
              />
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
